import { render, staticRenderFns } from "./QuestionListPage.vue?vue&type=template&id=5d6d90c1&scoped=true"
import script from "./QuestionListPage.vue?vue&type=script&lang=js"
export * from "./QuestionListPage.vue?vue&type=script&lang=js"
import style0 from "./QuestionListPage.vue?vue&type=style&index=0&id=5d6d90c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6d90c1",
  null
  
)

export default component.exports